import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { ItemStatusEnum } from '@/modules/common';
import {
  PageHeader,
  Spinner,
  useApiMutation,
  useApiQuery,
} from '@/modules/common';
import { Routes } from '@/router/routes';

import { OverlaysTable } from '../components';
import { OverlayItem } from '../types';

export const OverlaysPage: FC = () => {
  const navigate = useNavigate();

  const redirectToOverlayDetails = (item) => {
    navigate(Routes.OverlayDetails.replace(':id', item.id));
  };

  return (
    <div>
      <PageHeader
        title="Overlays"
        actions={[
          <Link
            to={Routes.NewOverlay}
            key="new-overlay"
            data-testid="add-new-overlay-link"
          >
            <Button data-testid="add-new-model-button">
              <PlusSquareIcon />
              Add new overlay
            </Button>
          </Link>,
        ]}
      />

      <OverlaysTable onClick={redirectToOverlayDetails} />
    </div>
  );
};
